import { client } from "../net/client";
import { useSignal } from "../net/signal";
import { menchPiece } from "../game/menchPiece";

/**
 * آدمکِ منچ (کاربر، ۲۵ اکتبر ۲۰۲۶): فقط خودِ دو آدمک — بی واژه‌ای کنارشان؛ بازیکن هر کدام را بخواهد لمس می‌کند.
 * سلیقه‌ی بازیکن است و نه قانونِ اتاق: در لابی بیرون از «بیشتر» می‌آید، و در اتاق برای **هر** نشسته — کسی که با
 * لینک یا کد آمده لابی را ندیده بود و پیش‌تر هیچ‌جا انتخابش نمی‌کرد (کاربر، ۲۵ اکتبر ۲۰۲۶). سرور صندلیِ اتاقِ
 * شروع‌نشده را هم با SetPiece عوض می‌کند و به همه خبر می‌دهد.
 */
export function MenchPiecePicker() {
  const piece = useSignal(menchPiece);
  return (
    <div className="row mnpiece" role="radiogroup" aria-label="آدمک من">
      <span className="mnlabel">آدمک من</span>
      {([0, 1] as const).map((v) => (
        <button key={v} role="radio" aria-checked={piece === v} aria-label={`آدمک ${v === 0 ? "یکم" : "دوم"}`}
                className={"chip mnpiece-opt" + (piece === v ? " on" : "")} onClick={() => client.setMenchPiece(v)}>
          <img src={`/art/mench/${v === 1 ? "g" : "p"}0-idle.webp`} alt="" width={39} height={52} />
        </button>
      ))}
    </div>
  );
}
